import React from "react";
import { TourData } from "../../../Types";

// STATE MANAGEMENT

import {
  useCurrentSceneStore,
  useSceneStore,
  useViewerStore,
  useWidePopupStore,
} from "../../../api/Zustand";
import {
  useCameraPositionStore,
  useCompassHeadingStore,
} from "../../../state management/zustand/gl-stores";

// QUERIES

import { UseSaveTour } from "../../../api/calls/Queries";

// THREEJS

import * as THREE from "three";

// GUI

import DownloadProgressBar from "../../common/DownloadProgressBar";
import { PlayIcon, CompassNeedle } from "../../Icons/exp-overlay-icons";

const Overlay = (props: { tourData: TourData }) => {
  const { isTakingScreenshot } = useWidePopupStore();

  const { currentSceneID } = useCurrentSceneStore();

  const { mutateAsync: saveTour, isPending: isSaving } = UseSaveTour();
  const { setViewer } = useViewerStore();

  const canGoToViewer: boolean = React.useMemo(() => {
    const currentScene = props.tourData.scenes.find(
      (one) => one.id === currentSceneID
    );
    if (currentScene?.hotspots.find((one) => one.EDIT_POS)) {
      return false;
    } else return true;
  }, [props.tourData, currentSceneID]);

  return (
    <div className="overlay">
      <DownloadProgressBar bottom={0} />
      <div className="compass">
        <Compass />
      </div>
      <div className="play">
        <br />

        {isSaving ? (
          <div id="spinner" style={{ width: 20, height: 20 }} />
        ) : (
          <PlayIcon
            onClick={() => {
              if (canGoToViewer && !isTakingScreenshot) {
                saveTour(props.tourData, { onSuccess: () => setViewer(true) });
              }
            }}
            width={"2.4rem"}
            height={"2.4rem"}
            fill="#fff"
            stroke="#222"
            strokeWidth={15}
          />
        )}
      </div>
    </div>
  );
};

const Compass = () => {
  const camera = useCameraPositionStore();

  const { scene } = useSceneStore();
  const { heading } = useCompassHeadingStore();

  const sceneNorth = React.useMemo(() => {
    let north = new THREE.Vector3(
      Math.sin((scene!?.north / 180) * Math.PI),
      0,
      -Math.cos((scene!?.north / 180) * Math.PI)
    );

    return north;
  }, [scene]);

  return (
    <div
      onClick={() => {
        camera.setCameraLookAt(sceneNorth);
      }}
      style={{
        transform: `rotate(${
          180 + (scene!?.north + (heading * 180) / Math.PI)
        }deg)`,
      }}
    >
      <div className="compass-needle wrapper">
        <CompassNeedle />
      </div>
    </div>
  );
};

export default Overlay;
